import React from "react";
import PropTypes from "prop-types";
import { Grid, Typography } from "@material-ui/core";
import useStyles from "./styles";

export default function TabSelector({ options, currentTab, setCurrentTab }) {
  const { tabBar, tab, activeTab, activeTabDecoration, content } = useStyles();
  return (
    <Grid item container xs={12}>
      <Grid
        item
        container
        xs={12}
        justify="flex-start"
        alignItems="center"
        className={tabBar}
      >
        {options.map(({ title, tabName }) => (
          <div
            className={`${tab} ${currentTab === tabName && activeTab}`}
            key={tabName}
            onClick={() => setCurrentTab(tabName)}
            role="presentation"
          >
            <Typography variant="body1">{title}</Typography>
            {currentTab === tabName && <div className={activeTabDecoration} />}
          </div>
        ))}
      </Grid>
      <Grid item container xs={12} className={content}>
        {options.find(({ tabName }) => currentTab === tabName)?.content}
      </Grid>
    </Grid>
  );
}

TabSelector.defaultProps = {};

TabSelector.propTypes = {
  options: PropTypes.array.isRequired,
  currentTab: PropTypes.string.isRequired,
  setCurrentTab: PropTypes.func.isRequired,
};
